export default "__VITE_ASSET__CFl78W9a__"